"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncerAllBones = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var FlexView_1 = require("../FlexView");
var Spacer_1 = require("../Spacer");
require("./announcer-all-bones.css");
var AnnouncerAllBones = /** @class */ (function (_super) {
    __extends(AnnouncerAllBones, _super);
    function AnnouncerAllBones() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderAction = function (action) {
            return (0, function_1.pipe)(O.fromNullable(action), (0, Option_1.map)(function (a) { return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('announcer-all-bones-content-action', a.icon, a.label ? 'announcer-all-bones-content-action-with-label' : ''), onClick: a.onClick }, { children: a.label ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "announcer-all-bones-content-action-label" }, { children: a.label })) : null }))); }), O.toNullable);
        };
        _this.renderPayload = function (payload) {
            return (0, function_1.pipe)(O.fromNullable(payload), (0, Option_1.map)(function (p) { return (0, jsx_runtime_1.jsx)("div", __assign({ className: "announcer-all-bones-payload" }, { children: p })); }), O.toNullable);
        };
        return _this;
    }
    AnnouncerAllBones.prototype.renderItem = function (item) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('announcer-all-bones-content', this.props.childrenSize) }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('announcer-all-bones-content-children', "announcer-all-bones-content-children-theme-".concat(this.props.theme)) }, { children: item.content })), this.renderAction(item.action)] })));
    };
    AnnouncerAllBones.prototype.buildContent = function () {
        var _this = this;
        switch (this.props.type) {
            case 'multiple':
                return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView, { children: this.props.items.map(function (item, index) { return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ vAlignContent: "bottom" }, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, xl: 4 }, { children: item.label })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, xl: 8 }, { children: _this.renderItem(item) }))] })) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12 }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ className: "announcer-all-bones-multiple-payload", hAlignContent: "right" }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, xl: 8 }, { children: _this.renderPayload(item.payload) })) })) })), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 0.2 })] }, index)); }) }));
            case 'single':
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.renderItem(this.props), this.renderPayload(this.props.payload)] }));
        }
    };
    AnnouncerAllBones.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "announcer-all-bones" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('announcer-all-bones-title', "announcer-all-bones-title-theme-".concat(this.props.theme)) }, { children: this.props.title })), this.buildContent()] })));
    };
    return AnnouncerAllBones;
}(React.PureComponent));
exports.AnnouncerAllBones = AnnouncerAllBones;
AnnouncerAllBones.defaultProps = {
    childrenSize: 'std',
    theme: 'default',
};
//# sourceMappingURL=AnnouncerAllBones.js.map